import { render, staticRenderFns } from "./PgaDeleteButton.vue?vue&type=template&id=a9750bce&"
import script from "./PgaDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./PgaDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9750bce')) {
      api.createRecord('a9750bce', component.options)
    } else {
      api.reload('a9750bce', component.options)
    }
    module.hot.accept("./PgaDeleteButton.vue?vue&type=template&id=a9750bce&", function () {
      api.rerender('a9750bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/PgaDeleteButton.vue"
export default component.exports